<template>
  <section class="new_css">
    <el-row class="new_header">
      <el-col v-if="buttonList.length > 0" :span="24" class="organizetoolbar" style="padding-bottom: 0px">
        <el-form :inline="true" ref="selectForm" :model="selectForm" class="select_form">
          <el-form-item label="所属年:">
            <el-input v-model="selectForm.regYear" placeholder="所属年"></el-input>
          </el-form-item>
          <el-form-item label="所属月:">
            <el-input v-model="selectForm.regMonth" placeholder="所属月"></el-input>
          </el-form-item>
          <el-form-item label="公司:">
            <el-select v-model="selectForm.factory" placeholder="公司" @change="factoryselectForm($event)">
              <el-option v-for="item in factoryselectFormLists" :key="item.Factory" :label="item.Factory" :value="item.Factory"></el-option>
            </el-select>
            </el-form-item>
          <!-- <el-form-item label="公司:">
            <el-select v-model="selectForm.AttributionUnit" placeholder="归属公司" @change="AttributionUnitselectForm($event)" style="width: 100%">
              <el-option v-for="item in AttributionUnitselectFormLists" :key="item.Id" :label="item.AttributionUnit" :value="item.AttributionUnit"></el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item label="部门:">
            <el-input v-model="selectForm.userDpt" placeholder="部门"></el-input>
          </el-form-item>
          <el-form-item label="所属公司:">
            <el-input v-model="selectForm.attributionUnit" placeholder="所属公司"></el-input>
          </el-form-item>
          <toolbar :buttonList="buttonList" @callFunction="callFunction" :buttonListmsg="buttonListmsg"></toolbar>
        </el-form>
      </el-col>
    </el-row>
    <div class="calc-height">
      <!--列表-->
      <el-table :data="users" highlight-current-row height="100%" @current-change="selectCurrentRow" class="new_table">
        <el-table-column fixed width='80' label="姓名" prop="UserName"></el-table-column>
        <el-table-column label="身份证号" prop="IDCard"></el-table-column>
        <el-table-column label="公司" prop="Factory"></el-table-column>
        <el-table-column label="部门" prop="UserDpt"></el-table-column>
        <el-table-column label="岗位" prop="UserPost"></el-table-column>
        <el-table-column width='100' label="用户状态" prop="UserState"></el-table-column>
        <el-table-column width='100' label="用工性质" prop="ContractNature"></el-table-column>
        <el-table-column width='120' label="电话" prop="MobilePhone"></el-table-column>
        <el-table-column width='120' label="上传时间" prop="CreateDate"></el-table-column>
        <el-table-column width='80' label="所属年" prop="RegYear"></el-table-column>
        <el-table-column width='80' label="所属月" prop="RegMonth"></el-table-column>
        <el-table-column width='100' label="应发工资" prop="ShouldSalary"></el-table-column>
        <el-table-column width='100' label="住房公积金扣除" prop="AccumuSalary"></el-table-column>
        <el-table-column width='100' label="保险扣除" prop="SafeMoney"></el-table-column>
        <el-table-column width='100' label="个人所得税" prop="PersonTaxSalary"></el-table-column>
        <el-table-column width='100' label="个人欠款" prop="SellSalary"></el-table-column>
        <el-table-column width='100' label="爱心基金" prop="LoveMoney"></el-table-column>
        <el-table-column width='100' label="其他扣款" prop="OtherSalary"></el-table-column>
        <el-table-column width='100' label="上半月已发放" prop="IssuedSalary"></el-table-column>
        <el-table-column width='100' label="实发工资" prop="UserMoney"></el-table-column>
        <el-table-column label="备注" prop="Remark"></el-table-column>
        <el-table-column label="所属公司" prop="AttributionUnit"></el-table-column>
      </el-table>
    </div>
    <!-- 分页器 -->
    <el-pagination align="center" @current-change="handleCurrentChange" :current-page="currentPage" :page-size="pageSize" layout="prev, pager, next, jumper,total" :page-count="total" :total="totaldata">
    </el-pagination>
  </section>
</template>
<script>
import util from "../../../util/date";
import * as validate from "../../../util/validate";
import {
  GetPersonTaxList,
  GetPersonTaxPageList,
  GetFactoryList,
} from "../../api/hr";
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/newToolbar";
export default {
  components: { Toolbar },
  data() {
    return {
      selectForm: {
        regYear: new Date().getFullYear(),
        regMonth:new Date().getMonth()+1,
        factory:"",
        userDpt:"",
        attributionUnit:"",
      },
      factoryLists:[],
      factoryselectFormLists:[],
      SalaryTypeLists: [],
      choosedusers: [],
      loading: true,
      currentPage: 1, // 当前页码
      total: null, // 总条数
      totaldata: null,
      pageSize: 20, // 每页的数据条数
      page: 1,
      SakaryVisible: false,
      buttonListmsg: "",
      users: [],
      operation: false, // true:新增, false:编辑
      buttonList: [],
    };
  },
  methods: {
    selectCurrentRow(val) {
      this.currentRow = val;
    },
    callFunction(item) {
      this[item.Func].apply(this, item);
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.page = val;
      this.getData(false);
    },
    handleExcel() {
      GetPersonTaxList({
        regYear: this.selectForm.regYear,
        regMonth: this.selectForm.regMonth,
        factory:this.selectForm.factory,
        userDpt:this.selectForm.userDpt,
        attributionUnit:this.selectForm.attributionUnit,
      }).then((res) => {
        if (res.data.success) {
          console.log(res);
          var header = [
             "姓名",
             "身份证号",
             "公司",
             "部门",
             "岗位",
             "用户状态",
             "用工性质",
             "电话",
             "上传时间",
             "所属年",
             "所属月",
             "应发工资",
             "住房公积金扣除",
             "保险扣除",
             "个人所得税",
             "个人欠款",
             "爱心基金",
             "其他扣款",
             "上半月已发放",
             "实发工资",
             "所属公司",
             "备注",
          ];
          var filter = [
              "UserName",
              "IDCard",
              "Factory",
              "UserDpt",
              "UserPost",
              "UserState",
              "ContractNature",
              "MobilePhone",
              "CreateDate",
              "RegYear",
              "RegMonth",
              "ShouldSalary",
              "AccumuSalary",
              "SafeMoney",
              "PersonTaxSalary",
              "SellSalary",
              "LoveMoney",
              "OtherSalary",
              "IssuedSalary",
              "UserMoney",
              "AttributionUnit",
              "Remark",
          ];
          var name = "个税核算";
          this.excelData(res.data.response, header, filter, name);
        } else {
          this.$message({
            message: res.data.msg,
            type: "error",
            duration: 5000,
          });
        }
      });
    },
    excelData(res, header, filter, name) {
      require.ensure([], () => {
        const {
          export_json_to_excel,
        } = require("../../../util/Export2Excel.js");
        const tHeader = header;
        const filterVal = filter;
        const list = res;
        const data = this.formatJson(filterVal, list);
        export_json_to_excel(tHeader, data, name);
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },
    factoryselectForm(id){
      let obj = {};
      obj = this.factoryselectFormLists.find((item) => {
        //model就是上面的数据源
        console.log(item);
        return item.Factory === id; //筛选出匹配数据
      });
      console.log(obj);
      this.SakaryForm.factory = obj.factory;
    },
    //获取列表
    getData(isCurrent = true) {
      if (isCurrent) {
        this.page = 1;
      }
      let para = {
        page: this.page,
        size: this.pageSize,
        regYear: this.selectForm.regYear,
        regMonth: this.selectForm.regMonth,
        factory:this.selectForm.factory,
        userDpt:this.selectForm.userDpt,
        attributionUnit:this.selectForm.attributionUnit
      };
      let para1 = {
        regYear: this.selectForm.regYear,
        regMonth: this.selectForm.regMonth
      };
      GetFactoryList(para1).then((res) => {
        console.log(res.data.response)
        this.factoryselectFormLists=res.data.response;
      });
      GetPersonTaxPageList(para).then((res) => {
        this.total = res.data.response.pageCount;
        this.totaldata = res.data.response.dataCount;
        this.users = res.data.response.data;
        this.loading = false;
      });
    },
    getButtonList2(routers) {
      let _this = this;
      routers.forEach((element) => {
        let path = this.$route.path.toLowerCase();
        if (element.path && element.path.toLowerCase() == path) {
          _this.buttonList = element.children;
          return;
        } else if (element.children) {
          _this.getButtonList(element.children);
        }
      });
    },
  },
  mounted() {
    this.getData();
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    let buttons = window.localStorage.buttList
      ? JSON.parse(window.localStorage.buttList)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers, buttons);
  },
};
</script>
<style scoped>
</style>

